 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/title-page'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import CONTENTS from '@/components/contents'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import CHAPTER001 from '@/components/chapter-001'
 import CHAPTER002 from '@/components/chapter-002'
 import CHAPTER003 from '@/components/chapter-003'
 import CHAPTER004 from '@/components/chapter-004'
 import CHAPTER005 from '@/components/chapter-005'
 import CHAPTER006 from '@/components/chapter-006'
 import CHAPTER007 from '@/components/chapter-007'
 import CHAPTER008 from '@/components/chapter-008'
 import CHAPTER009 from '@/components/chapter-009'
 import CHAPTER010 from '@/components/chapter-010'
 import CHAPTER011 from '@/components/chapter-011'
 import CHAPTER012 from '@/components/chapter-012'
 import CHAPTER013 from '@/components/chapter-013'
 import CHAPTER014 from '@/components/chapter-014'
 import STOPINTHENAMEOFLOVE from '@/components/stop-in-the-name-of-love'
 import LOVINGALLOFME from '@/components/loving-all-of-me'
 import KINGOFDURABIA from '@/components/king-of-durabia'
 import LOVINGMEFORME from '@/components/loving-me-for-me'
 import UNCATEGORIZED30DAYSOFME from '@/components/uncategorized-30-days-of-me'
 import ABOUTNALEIGHNAKAI from '@/components/about-naleighna-kai'
 import ABOUTLAAMMITAI from '@/components/about-la-ammitai'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/acknowledgments",
 			"name" : "acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/chapter-001",
 			"name" : "chapter-001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js